if (document.getElementById('page-review')) {
  pageReview()
}

function pageReview() {
  const formRequireTargetList = document.getElementsByClassName('js-require')
  for (const iterator of formRequireTargetList) {
    formRequire(iterator)
  }

  window.addEventListener('input', function (e) {
    for (const iterator of formRequireTargetList) {
      formRequire(iterator)
    }
  })

  window.addEventListener('change', function (e) {
    for (const iterator of formRequireTargetList) {
      formRequire(iterator)
    }
  })
}

function formRequire(item) {
  const targetList = item.dataset.require.split(',') // ,区切りで配列に変換
  const sendBtn = item.querySelector('.js-require--send')

  if (!sendBtn) {
    return
  }
  for (const iterator of targetList) {
    const input = document.querySelector('[name="' + iterator + '"]')
    if (input !== null && input.type && (input.type === 'radio' || input.type === 'checkbox')) {
      const check = document.querySelector('[name="' + iterator + '"]:checked')
      if (!check) {
        sendBtn.classList.add('is-disable')
        return
      }
    } else {
      if (input !== null && input.value === '') {
        sendBtn.classList.add('is-disable')
        return
      }
    }
  }

  sendBtn.classList.remove('is-disable')
}
